import  oktaAuth  from "../../Model/oktaAuthSingleton"
import { serverUrl } from "../../Model/serverConfig"

export const fetchLeanCanvasData = async (tableId: string, viewId?: string) => {
    let url = `${serverUrl}/lean-canvas/${tableId}/?`;
    if (viewId) {
        url += `viewId=${viewId}`;
    }

    try {
        // Get the current ID token from Okta
        const accessToken = await oktaAuth.getIdToken();
        console.log("🚀 ~ fetchLeanCanvasData ~ accessToken:", accessToken)

        // If the ID token is unavailable, redirect the user to sign in
        if (!accessToken) {
            oktaAuth.signInWithRedirect();
            return [];
        }

        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });

        console.log("🚀 ~ fetchLeanCanvasData ~ response:", response)

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching data from server:", error);
        return [];
    }
}
